/** Pure: ¿este FeriaMaterial pertenece a este FeriaProveedor? */
export function materialBelongsToSupplier(matRow, supplierRow) {
  if (!supplierRow) return true;
  const cod = supplierRow.CODPROV || supplierRow.proveedor?.CODPROV;
  const fab = supplierRow.id_Fabrica || supplierRow.fabrica?.id_Fabrica;
  if (cod) {
    return (
      Number(matRow.CODPROV) === Number(cod) ||
      Number(matRow.material?.Proveedor) === Number(cod)
    );
  }
  if (fab) {
    return Number(matRow.id_Fabrica) === Number(fab);
  }
  return false;
}

export function unassignedFeriaMaterials(materiales = [], proveedores = []) {
  return (materiales || []).filter(
    (m) => !(proveedores || []).some((p) => materialBelongsToSupplier(m, p)),
  );
}

export function supplierDisplayName(row, unnamed = "Sin nombre") {
  if (!row) return unnamed;
  return (
    row.proveedor?.N_PROVEEDOR ||
    row.fabrica?.NombreFabrica ||
    row.Nombre ||
    unnamed
  );
}
